import { IClassname } from '@/lib/shared/model/classname';

export const FireExtinguisher = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7221 6.60434V3.85938H12.1662V6.60434C11.2436 6.87941 10.4344 7.44483 9.8588 8.21657C9.28322 8.98831 8.97201 9.92517 8.97144 10.8879V29.4177C8.97144 29.7566 9.10607 30.0817 9.34573 30.3213C9.58538 30.561 9.91043 30.6956 10.2494 30.6956H16.6389C16.9779 30.6956 17.3029 30.561 17.5426 30.3213C17.7822 30.0817 17.9169 29.7566 17.9169 29.4177V10.8879C17.9163 9.92517 17.6051 8.98831 17.0295 8.21657C16.4539 7.44483 15.6447 6.87941 14.7221 6.60434Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41561 1.30371L12.1662 3.85954C10.3022 3.85954 8.51441 4.60005 7.19631 5.91816C5.8782 7.23626 5.1377 9.024 5.1377 10.8881V26.862"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1389 1.31028C26.2291 1.29827 26.3208 1.30566 26.4079 1.33194C26.4949 1.35822 26.5754 1.40279 26.6439 1.46268C26.7124 1.52256 26.7673 1.59637 26.8049 1.67918C26.8426 1.76199 26.8621 1.85188 26.8622 1.94285V5.7766C26.863 5.8681 26.8441 5.95871 26.8069 6.04229C26.7696 6.12587 26.7149 6.20048 26.6463 6.26106C26.5777 6.32164 26.4969 6.36679 26.4094 6.39344C26.3219 6.4201 26.2296 6.42764 26.1389 6.41556L18.3871 5.38172C18.0801 5.34085 17.7985 5.18992 17.5944 4.95698C17.3904 4.72405 17.2779 4.42496 17.2778 4.11531V3.61053C17.2776 3.30066 17.39 3.00126 17.594 2.76806C17.7981 2.53485 18.0799 2.38374 18.3871 2.34284L26.1389 1.31028Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7222 3.85938H17.278"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9168 26.8627H14.722C14.6381 26.8627 14.555 26.8462 14.4774 26.8141C14.3999 26.782 14.3295 26.7349 14.2702 26.6756C14.2108 26.6163 14.1638 26.5458 14.1316 26.4683C14.0995 26.3908 14.083 26.3077 14.083 26.2238V13.4446C14.083 13.2752 14.1503 13.1126 14.2702 12.9928C14.39 12.873 14.5525 12.8057 14.722 12.8057H17.9168"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
